var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Publisher Group',
        to: '/publisher-group'
      }, {
        label: 'Edit'
      }],
      "title": "Edit Publisher Group"
    }
  }), _c('div', {
    staticClass: "flex-col justify-start items-center bg-white w-full shadow-sm rounded-lg"
  }, [_c('FormDataPublisherGroup', {
    attrs: {
      "form": _vm.form,
      "vendorsAlready": _vm.vendorsAlready,
      "invalidName": _vm.invalidName,
      "invalidNameEmpty": _vm.invalidNameEmpty,
      "invalidVendorsEmpty": _vm.invalidVendorsEmpty
    },
    on: {
      "update:invalidName": function ($event) {
        _vm.invalidName = $event;
      },
      "update:invalid-name": function ($event) {
        _vm.invalidName = $event;
      },
      "update:invalidNameEmpty": function ($event) {
        _vm.invalidNameEmpty = $event;
      },
      "update:invalid-name-empty": function ($event) {
        _vm.invalidNameEmpty = $event;
      },
      "update:invalidVendorsEmpty": function ($event) {
        _vm.invalidVendorsEmpty = $event;
      },
      "update:invalid-vendors-empty": function ($event) {
        _vm.invalidVendorsEmpty = $event;
      }
    }
  }), _c('div', {
    staticClass: "px-4 pb-4"
  }, [_c('button', {
    staticClass: "bg-blue-700 text-white rounded-lg p-1.5 px-2",
    on: {
      "click": function ($event) {
        return _vm.editPublisherGroup();
      }
    }
  }, [_vm._v("Save")]), _c('button', {
    staticClass: "bg-white text-gray-700 border ml-3 rounded-lg p-1.5 px-2",
    on: {
      "click": function ($event) {
        return _vm.handleCancel();
      }
    }
  }, [_vm._v("Cancel")])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }